import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard {
  constructor(
    private _identityService: AuthService,
    private _router: Router
  ) {}

  // If canActivate, ActivatedRouteSnapshot contains the future route that
  // will be activated and RouterStateSnapshot contains the future RouterState
  // of the application.
  canActivate(state: RouterStateSnapshot) {
    if (this._identityService.isLoggedIn()) {
      return true;
    }

    this._identityService.logout();
    // Store the url that the user attempted to navigate to for redirecting
    this._identityService.redirectUrl = state.url;

    // Navigate to signin
    this._router.navigate(['']);

    // Cancel the current navigation
    return false;
  }
}
